// Returns true when the current URL path indicates an applink-originated navigation.
// Callers that need to carry the applink signal past URL redirects should capture
// this value early and thread it as a parameter rather than relying on global state.
export default function isApplinkRoute(): boolean {
    return window.location.pathname.includes('/applink/');
}
